// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmailSetup_root__Vb2TA {
  padding: 15px 40px 90px 40px;
  height: calc(100vh - 188px);
  overflow-y: scroll;
  color: var(--color-font-10);
  overflow: scroll;
  max-width: 1125px;
}

.EmailSetup_root__Vb2TA p {
  font-size: 16px;
}

.EmailSetup_settlement_portal_title__w5SQA {
  display: flex;
  align-items: center;
}

.EmailSetup_email_icon__WilC7 {
  padding-right: 10px;
}

.EmailSetup_arrow_icon__WF5Lh {
  padding: 0px 20px;
  color: var(--color-theme-silver);
}

.EmailSetup_email_setup_header__u932M {
  
  width: 800px;
}

.EmailSetup_email_setup_dropdown__YnqQm {
  min-width: 370px !important;
}

.EmailSetup_btn_select_email_setup__eW0hz {
  color: var(--color-theme-10) !important;
  border-color: var(--color-theme-10) !important;
  width: 370px !important;
  display: flex !important;
  justify-content: space-between !important;
}

.EmailSetup_menu_item__x4Sxt {
  display: flex;
  align-items: center;
}

.EmailSetup_menu_item__x4Sxt p {
  margin: 2px;
  padding-right: 20px;
}

.EmailSetup_check_icon__Ku3tu {
  padding-bottom: 3px;
  padding-left: 10px;
}

.EmailSetup_email_setup_description__IekXv {
  padding-bottom: 20px;
}

.EmailSetup_select_setup_label__xiVaV {
  color: var(--color-theme-lightgray);
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/EmailSetup/EmailSetup.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;EAC9C,uBAAuB;EACvB,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".root {\n  padding: 15px 40px 90px 40px;\n  height: calc(100vh - 188px);\n  overflow-y: scroll;\n  color: var(--color-font-10);\n  overflow: scroll;\n  max-width: 1125px;\n}\n\n.root p {\n  font-size: 16px;\n}\n\n.settlement_portal_title {\n  display: flex;\n  align-items: center;\n}\n\n.email_icon {\n  padding-right: 10px;\n}\n\n.arrow_icon {\n  padding: 0px 20px;\n  color: var(--color-theme-silver);\n}\n\n.email_setup_header {\n  \n  width: 800px;\n}\n\n.email_setup_dropdown {\n  min-width: 370px !important;\n}\n\n.btn_select_email_setup {\n  color: var(--color-theme-10) !important;\n  border-color: var(--color-theme-10) !important;\n  width: 370px !important;\n  display: flex !important;\n  justify-content: space-between !important;\n}\n\n.menu_item {\n  display: flex;\n  align-items: center;\n}\n\n.menu_item p {\n  margin: 2px;\n  padding-right: 20px;\n}\n\n.check_icon {\n  padding-bottom: 3px;\n  padding-left: 10px;\n}\n\n.email_setup_description {\n  padding-bottom: 20px;\n}\n\n.select_setup_label {\n  color: var(--color-theme-lightgray);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `EmailSetup_root__Vb2TA`,
	"settlement_portal_title": `EmailSetup_settlement_portal_title__w5SQA`,
	"email_icon": `EmailSetup_email_icon__WilC7`,
	"arrow_icon": `EmailSetup_arrow_icon__WF5Lh`,
	"email_setup_header": `EmailSetup_email_setup_header__u932M`,
	"email_setup_dropdown": `EmailSetup_email_setup_dropdown__YnqQm`,
	"btn_select_email_setup": `EmailSetup_btn_select_email_setup__eW0hz`,
	"menu_item": `EmailSetup_menu_item__x4Sxt`,
	"check_icon": `EmailSetup_check_icon__Ku3tu`,
	"email_setup_description": `EmailSetup_email_setup_description__IekXv`,
	"select_setup_label": `EmailSetup_select_setup_label__xiVaV`
};
export default ___CSS_LOADER_EXPORT___;
